import { useState, useEffect, forwardRef } from "react"
import PropTypes from "prop-types"
import { KEY_CODES } from "helpers/keyboard"
import FieldCell from "components/securities-table/field-cell"
import { noop } from "lodash"

const EditableField = forwardRef(({ component = "div", id, content, onChange, item, onBlur = noop }, ref) => {
  const [originalValue, setOriginalValue] = useState()
  const [value, setValue] = useState("")
  // To prevent the input from being uncontrolled when initialValue is undefined
  useEffect(() => {
    setValue(content ?? "")
  }, [content])

  const handleChange = (e) => {
    if (!originalValue) {
      setOriginalValue(e.targetValue)
    }
    setValue(e.target.value)
  }

  const handleOnBlur = (e) => {
    if (content !== e.target.value) {
      onChange(item, content, e?.target?.value)
    }
  }

  const handleKeyDown = (e) => {
    switch (e.keyCode) {
      case KEY_CODES.ENTER:
      case KEY_CODES.TAB:
        onBlur()
        handleOnBlur(e)
        break
      case KEY_CODES.ESCAPE:
        onBlur()
        break
    }
  }

  // We need to be able to display the component as a td
  const Component = component

  return <Component ref={ref} elevation={2} component={component} className="editable-cell">
    <FieldCell
      key={id}
      {...{
        isInput: true,
        editable: true,
        value,
        onKeyDown: handleKeyDown,
        onChange: handleChange,
      onBlur: handleOnBlur,
      useTextField: true,
    }}
    />
  </Component>
})

EditableField.displayName = "EditableField"
EditableField.propTypes = {
  item: PropTypes.object.isRequired,
  component: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
}

export default EditableField
